import React from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

export default function Example() {
  return <DayPicker showOutsideDays />;
}



// WEBPACK FOOTER //
// ./src/code-samples/examples/customization-outside.js